import { isNil } from "lodash-es";
import { Directive } from "vue";

/**
 * Add a common highlight directive, which applies a class to trigger a highlight on value changes.
 */
export const wtcHighlightDirective: Directive = {
    updated: (el, { value, oldValue }) => {
        if (!isNil(value) && value != oldValue) {
            el.classList.remove("animate-highlight-value-change");
            setTimeout(() => {
                el.classList.add("animate-highlight-value-change");
            }, 1);
        }
    }
};
